export default {
  'component.feedback.title': 'Din tilbakemelding',
  'component.feedback.notice':'Denne delen kommer fra Survey Monkey',
};
